import { PRIORITY_COLORS } from "./constants";

export const getPriorityColor = (priority) => {
  const colors = {
    high: { main: "#EF4444", light: "#FEE2E2", text: "#991B1B" },
    medium: { main: "#F59E0B", light: "#FEF3C7", text: "#92400E" },
    low: { main: "#3B82F6", light: "#DBEAFE", text: "#1E3A8A" },
  };
  return colors[priority] || colors.low;
};

export const getUserInfo = () => {
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("username");
  const userRole = localStorage.getItem("userRole");
  return { userId, userName, userRole };
};

export const formatDateForInput = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
